module.exports = {"652324100":"玛纳斯镇","652324101":"乐土驿镇","652324102":"包家店镇","652324103":"凉州户镇","652324104":"北五岔镇","652324105":"六户地镇","652324106":"兰州湾镇","652324201":"广东地乡","652324202":"清水河子哈萨克民族乡","652324203":"塔西河乡","652324204":"旱卡子滩乡","652324400":"玛电工业区","652324401":"园艺场","652324402":"自治区林业厅玛纳斯平原林场","652324403":"新疆农科院玛纳斯试验站","652324520":"兵团农六师新湖农场","652324521":"兵团一四七团","652324522":"兵团一四八团","652324523":"兵团一四九团","652324524":"兵团一五零团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652324.json
// module id = 2858
// module chunks = 0